import "./TeacherAttendClass.css";
import { Bell } from "lucide-react";
import React, { useState, useContext, useEffect, useCallback } from "react";
import AdminNav from "../Navbars/AdminNav";
import StudentNav from "../Navbars/StudentNav";
import GuestNav from "../Navbars/GuestNav";
import Header from "../Header";
import Footer from "../Footer";
import { UserContext } from "../UserContext";
import TeacherNav from "../Navbars/TeacherNav";
import puzzleicon from "./ActivityIcons/AP_ModuleProjectLesson.png";
import WrittenActivityImage from "./ActivityIcons/WrittenActivity.png";
import MCQActivityImage from "./ActivityIcons/MCQActivity.png";
import VideoActivityImage from "./ActivityIcons/AP_VideoIcon.png";
import SpeedQuizActivityImage from "./ActivityIcons/SpeedQuiz.png";
import OralActivityImage from "./ActivityIcons/AP_Oralicon.png";
import MentalActivityImage from "./ActivityIcons/MentalActivity.png";
import { toast } from "react-toastify";

import eyeIcon from "./eyeicon.png";
import mental from "./ActivityIcons/MentalActivity.png";
import oral from "./ActivityIcons/OralActivity.png";
import speedquizz from "./ActivityIcons/SpeedQuiz.png";
import mcq from "./ActivityIcons/MCQActivity.png";
import { useNavigate } from "react-router-dom/dist/umd/react-router-dom.development";
import { useLocation } from "react-router-dom";
import { Link } from "react-router-dom";
import axios from "axios";
import ViewActivityModal from "./ViewActivityModal";

const TeacherAttendClass = ({ selectedCourse }) => {
  // Configuration for activity name truncation
  const ACTIVITY_NAME_MAX_LENGTH = 25;

  // Helper function to truncate activity name
  const truncateActivityName = (name) => {
    if (name && name.length > ACTIVITY_NAME_MAX_LENGTH) {
      return name.substring(0, ACTIVITY_NAME_MAX_LENGTH) + "...";
    }
    return name;
  };

  const [selectedLesson, setSelectedLesson] = useState("");
  const [selectedModule, setSelectedModule] = useState("");
  const [selectedStudent, setSelectedStudent] = useState("");

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const selectedCourseData = JSON?.parse(queryParams.get("selectedCourseData"));
  var selectedClassLink = queryParams?.get("selectedClass");
  var selected_Class_id = queryParams?.get("selectedClassId");
  // console.log("selected_Class_id", selected_Class_id);

  // if (selectedClassLink?.startsWith("https://")) {
  //   selectedClassLink = selectedClassLink?.slice(8);
  // }
  //////////////////////////////////////
  let courseData = null;
  const selectedClassId = queryParams?.get("selectedClassId") || null;
  try {
    const selectedCourseData = queryParams.get("selectedCourseData");

    courseData = selectedCourseData
      ? JSON.parse(decodeURIComponent(selectedCourseData))
      : null;
  } catch (error) {
    console.error("Error parsing selectedCourseData:", error);
  }

  // Extract `selectedClass`
  const selectedClass = queryParams.get("selectedClass");

  // Find the matching class and get its Class_id
  let classId = 0;
  if (selectedClassId) {
    classId = selectedClassId;
  } else {
    classId = courseData?.classes?.find(
      (cls) => cls.ClassLink === selectedClass
    )?.Class_id;
  }

  // alert(classId)
  //console.log("Selected Course Data: ", selectedCourseData);

  const [courseLessons, setCourseLessons] = useState("");
  const [courseModules, setCourseModules] = useState("");
  const [filteredLessons, setFilteredLessons] = useState("");
  const [lessonActivities, setLessonActivities] = useState("");
  const [lessonProjects, setLessonProjects] = useState("");
  const [moduleProjects, setModuleProjects] = useState("");
  const [courseStudents, setCourseStudents] = useState("");
  const [studentProgress, setStudentProgress] = useState(null);
  const [assignedLesson, setAssignedLesson] = useState(null); // NEW: Track bache ka actual current lesson
  const [selectedLessonteacher, setSelectedLessonTeacher] = useState("");
  const [uploadedFile, setUploadedFile] = useState(null);
  const [lessonMaterials, setLessonMaterials] = useState([]);
  const [adminLessonMaterials, setAdminLessonMaterials] = useState([]);
  const [materialDescription, setMaterialDescription] = useState("");
  const [adminMaterialDescription, setAdminMaterialDescription] = useState("");
  const [adminUploadedFile, setAdminUploadedFile] = useState(null);
  const {
    isAdmin,
    isTeacher,
    isStudent,
    isGuest,
    setUserRole,
    setUserInfo,
    userInfo,
  } = useContext(UserContext);
  // const [detailedStudentProgress, setDetailedStudentProgress] = useState('');

  //console.log("Course Object: ", selectedCourseData);
  function fetchCourses() {
    axios
      .get(
        `${(process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_LOCAL_SERVER_API)}/getUserDetailsFromCourseID/${selectedCourseData.Course_id}/${classId}`
      )
      .then((response) => {
        //console.log("Studdents:", response.data.userDetails);
        setCourseStudents(response.data.userDetails);
      })
      .catch((error) => {
        console.error("Error fetching getStudents:", error);
      });
  }
  async function teacherId(User_id) {
    return await fetch(
      `${(process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_LOCAL_SERVER_API)}/teacherFromId/${User_id}`
    ).then((res) => {
      res.json().then((data) => {
        axios
          .get(
            `${(process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_LOCAL_SERVER_API)}/getUserDetailsFromCourseIDTeacherId/${selectedCourseData.Course_id}/${data?.teacher_id}/${classId}`
          )
          .then((response) => {
            setCourseStudents(response.data.userDetails);
          })
          .catch((error) => {
            console.error("Error fetching Students:", error);
          });
        // setUserId(data?.teacher_id);
      });
    });
  }

  // useEffect(() => {

  // }, [isAdmin, isTeacher, isStudent, isGuest]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(
          `${(process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_LOCAL_SERVER_API)}`,
          {
            credentials: "include",
          }
        );
        const userInfo = await response.json();
        setUserInfo(userInfo);
        // teacherId(userInfo?.User_id)
        if (userInfo?.usertype) {
          setUserRole(userInfo.usertype);
          if (userInfo.usertype == "Teacher") {
            teacherId(userInfo?.User_id);
          } else {
            fetchCourses();
          }
        }
        //console.log("Avatar: ", userInfo?.avatar);
      } catch (err) {
        console.log("Error in fetchData:", err);
      }
    };

    fetchData();

    //console.log("Selected Course ID: ", selectedCourseData.Course_id);
    //console.log("Getting all the Lessons against that Course ID");
    axios
      .get(
        `${(process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_LOCAL_SERVER_API)}/getLessonsFromCourseID/${selectedCourseData.Course_id}`
      )
      .then((response) => {
        //console.log(".......Lesssons:", response.data.lessons);
        setCourseLessons(response.data.lessons);
        setFilteredLessons(response.data.lessons);
      })
      .catch((error) => {
        console.error("Error fetching getLessonsFromCourseID:", error);
      });

    //Getting all the Modules against that course ID
    //console.log("Getting all the Modules against that course ID");
    axios
      .get(
        `${(process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_LOCAL_SERVER_API)}/getModulesFromCourseID/${selectedCourseData.Course_id}`
      )
      .then((response) => {
        //console.log("Modddules:", response.data.modules);
        setCourseModules(response.data.modules);
      })
      .catch((error) => {
        console.error("Error fetching getLessonsFromCourseID:", error);
      });
  }, [selectedCourse, location.search, selectedCourseData?.Course_id]);

  const [lessonPlanData, setLessonPlanData] = useState("");

  const [activeIndex, setActiveIndex] = useState(null);

  const handleClick = (index) => {
    if (activeIndex === index) {
      setActiveIndex(null);
    } else {
      setActiveIndex(index);
    }
  };

  const [isDialogOpen, setDialogOpen] = useState(false);

  const [selectedLessonActivityID, setSelectedLessonActivityID] =
    useState(null);

  const handleOpenDialog = (lessonActivityID) => {
    setSelectedLessonActivityID(lessonActivityID);
    setDialogOpen(true);
  };

  const handleCloseDialog = () => {
    setDialogOpen(false);
  };

  // Function to format lesson plan text with line breaks and bullet points
  const formatLessonPlanText = (text) => {
    if (!text) return "";

    // Split text by periods, but preserve www. and .com
    let formattedText = text
      .replace(/\.(?!\w)/g, ".\n") // Add line break after periods that are not followed by word characters
      .replace(/www\./g, "www_DOT_") // Temporarily replace www.
      .replace(/\.com/g, "DOT_com") // Temporarily replace .com
      .replace(/\./g, ".\n") // Add line breaks after all remaining periods
      .replace(/www_DOT_/g, "www.") // Restore www.
      .replace(/DOT_com/g, ".com"); // Restore .com

    // Split by lines and process each line
    const lines = formattedText.split("\n");
    const formattedLines = lines
      .map((line, index) => {
        const trimmedLine = line.trim();
        if (!trimmedLine) return null;

        // Check if line starts with * or ->
        if (trimmedLine.startsWith("*") || trimmedLine.startsWith("->")) {
          const content = trimmedLine.replace(/^[\*\-]+/, "").trim(); // Remove leading * or ->
          return (
            <li key={index} style={{ marginBottom: "5px" }}>
              {content}
            </li>
          );
        }

        // Check if line contains * or -> (not at start)
        if (trimmedLine.includes("*") || trimmedLine.includes("->")) {
          const parts = trimmedLine.split(/(\*|->)/);
          return (
            <div key={index} style={{ marginBottom: "5px" }}>
              {parts.map((part, partIndex) => {
                if (part === "*" || part === "->") {
                  return (
                    <li
                      key={partIndex}
                      style={{ display: "inline", marginLeft: "20px" }}
                    >
                      {/* Remove the * or -> symbol since we're using bullet styling */}
                    </li>
                  );
                }
                return part;
              })}
            </div>
          );
        }

        return (
          <div key={index} style={{ marginBottom: "5px" }}>
            {trimmedLine}
          </div>
        );
      })
      .filter((line) => line !== null);

    return formattedLines;
  };

  const handleLessonChange = (e) => {
    axios
      .get(
        `${(process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_LOCAL_SERVER_API)}/getActivitiesFromLessonID/${e.target.value}`
      )
      .then((response) => {
        //console.log("Activities:", response.data.activities);
        setLessonActivities(response.data.activities);
        // setCourseLessons(response.data.lessons);
      })
      .catch((error) => {
        console.error("Error fetching getLessonsFromCourseID:", error);
      });

    //Lesson Project Details
    //console.log("Calling Lesson Project API...");
    axios
      .get(
        `${(process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_LOCAL_SERVER_API)}/getLessonProjectsFromLessonID/${e.target.value}`
      )
      .then((response) => {
        //console.log("Lesson Projects:", response.data.lessonProjects);
        setLessonProjects(response.data.lessonProjects);
        // setCourseLessons(response.data.lessons);
      })
      .catch((error) => {
        console.error("Error fetching getLessonsFromCourseID:", error);
      });

    setSelectedLesson(e.target.value);

    // Get Lesson Plan
    axios
      .get(
        `${(process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_LOCAL_SERVER_API)}/getLessonPlan/${e.target.value}`
      )
      .then((response) => {
        setLessonPlanData(response.data.lessonPlan);
      })
      .catch((error) => {
        console.error("Error fetching getLessonPlan:", error);
      });

    // NEW: If a student is already selected, update their progress view for the new lesson
    if (selectedStudent) {
      fetchStudentProgress(selectedStudent, selectedCourseData.Course_id, e.target.value);
    }
  };
  const handleModuleChange = (e) => {
    //console.log("Calling Module Project API...");
    //console.log("Module Project e.target.value:", e.target.value);
    axios
      .get(
        `${(process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_LOCAL_SERVER_API)}/getModuleProjectsFromModuleID/${e.target.value}`
      )
      .then((response) => {
        //console.log("Module Projects:", response.data);
        //console.log("Module Projects:", response.data.moduleProjects);
        setModuleProjects(response.data.moduleProjects);
        // setCourseLessons(response.data.lessons);
      })
      .catch((error) => {
        console.error("Error fetching getLessonsFromCourseID:", error);
      });

    // setSelectedModule(e.target.value);
  };
  const [currentClassLink, setCurrentClassLink] = useState(selectedClassLink);
  const [polling, setPolling] = useState(null);
  const [isRefreshing, setIsRefreshing] = useState(false);

  const isProgressEqual = (oldData, newData) => {
    return JSON.stringify(oldData) === JSON.stringify(newData);
  };

  const fetchStudentProgress = useCallback(
    async (studentId, courseId, lessonId = null) => {
      // If no lessonId provided, try to use the selectedLesson state
      const targetLessonId = lessonId || selectedLesson;

      setIsRefreshing(true);
      try {
        const url = new URL(`${(process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_LOCAL_SERVER_API)}/getStudentProgressByCourse/${studentId}/${courseId}`);
        if (targetLessonId) {
          url.searchParams.append("lesson_id", targetLessonId);
        }

        const response = await axios.get(url.toString());

        const newProgressData = response.data.studentProgress;

        // NEW: Update assigned lesson metadata from backend response
        if (response.data.lessonName) {
          setAssignedLesson({
            id: response.data.currentLessonId,
            name: response.data.lessonName
          });
        }

        // Only update if data has changed
        if (!isProgressEqual(studentProgress, newProgressData)) {
          setStudentProgress(newProgressData);
          console.log("Student Progress Updated:", newProgressData);
        }
      } catch (error) {
        console.error("Error fetching Student Progress:", error);
      } finally {
        setIsRefreshing(false);
      }
    },
    [studentProgress, selectedLesson]
  );

  const handleStudentChange = (e) => {
    const studentId = e.target.value;
    setSelectedStudent(studentId);

    // Clear existing polling interval
    if (polling) {
      clearInterval(polling);
    }

    if (studentId) {
      // Set up new polling for the selected student
      const newPollInterval = setInterval(() => {
        fetchStudentProgress(studentId, selectedCourseData.Course_id, selectedLesson);
      }, 10000);

      setPolling(newPollInterval);

      // Initial fetch
      fetchStudentProgress(studentId, selectedCourseData.Course_id, selectedLesson);
    } else {
      setStudentProgress(null);
    }
  };

  useEffect(() => {
    return () => {
      if (polling) {
        clearInterval(polling);
      }
    };
  }, []);

  const handleCourseSelect = (course) => {
    //console.log("Selected Course in AttendClass:", course);
    selectedCourse(course);
    // setSelectedCourse(course);
  };

  // const handleActivityResultClick = (StudentId, activityId) => {
  //   let route = "/ActivityResult";

  //   window.location.assign(`${route}?studentId=${StudentId}`);
  // };

  const handleActivityResultClick = (studentId, activityId) => {
    let route = "/ActivityResult";

    const queryParams = new URLSearchParams();
    queryParams.set("studentId", studentId);
    queryParams.set("activityId", activityId);

    const queryString = queryParams.toString();

    const url = `${route}?${queryString}`;

    window.open(url, "_blank");
  };

  const handleActivityClick = (
    activityType,
    activityID1,
    ActivityLink = null
  ) => {
    let route = "";

    if (activityType === "MCQ") {
      route = "/MCQActivity";
    } else if (activityType === "Written") {
      route = "/WrittenActivity";
    } else if (activityType === "Video") {
      route = "/VideoActivity";
    } else if (activityType === "Speed Quiz") {
      route = "/SpeedQuizActivity";
    } else if (activityType === "Mental") {
      route = "/MentalActivity";
    } else if (activityType === "Oral") {
      route = "/OralActivity";
    } else if (activityType === "Game") {
      ActivityLink && window.open(ActivityLink, "_blank");
      // setRefresh && setRefresh((val) => !val);
      return;
    }

    //console.log("This is route: ", route);
    window.open(`${route}?activityId=${activityID1}`, "_blank");
  };

  const [myteacherid, setTeacherid] = useState();

  useEffect(() => {
    const fetchTeacherid = async () => {
      if (userInfo && userInfo.User_id) {
        try {
          const teacherIdResponse = await axios.get(
            `${(process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_LOCAL_SERVER_API)}/api/teacherlessonmaterial/getTeacherId/${userInfo.User_id}`
          );
          setTeacherid(teacherIdResponse.data.teacher_id);
        } catch (error) {
          console.log(error);
        }
      }
    };

    fetchTeacherid();
  }, [userInfo]);

  const determineUserRole = (usertype) => {
    //console.log("In home.js:", usertype);
    if (usertype === "Student") return "Student";
    else if (usertype === "Teacher") return "Teacher";
    else if (usertype === "Admin") return "Admin";
    else return "guest";
  };

  const navigate = useNavigate();
  const onLogin = (usertype) => {
    const userRole = determineUserRole(usertype);
    //  console.log("Calling setUserRole.")
    setUserRole(userRole);
  };

  async function onLogout() {
    //console.log("inside Onlogout.");
    await fetch(`${(process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_LOCAL_SERVER_API)}/logout`, {
      credentials: "include",
      method: "POST",
    });
    setUserInfo(null);
    setUserRole("guest");
    navigate("/");
  }
  const username = userInfo?.username;
  const _avatar_ = userInfo?.avatar;

  const handleTeacherLessonChange = async (event) => {
    setSelectedLessonTeacher(event.target.value);
    console.log("My Lesson", selectedLessonteacher);

    if (event.target.value && myteacherid) {
      try {
        const response = await axios.get(
          `${(process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_LOCAL_SERVER_API)}/api/teacherlessonmaterial/lessonmaterial?User_id=${userInfo.User_id}&Lesson_id=${event.target.value}`
        );
        setLessonMaterials(response.data);
      } catch (error) {
        console.error("Error fetching lesson materials:", error);
        // toast.error("Failed to fetch lesson materials");
        setLessonMaterials([]);
      }
    } else {
      try {
        const response = await axios.get(
          `${(process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_LOCAL_SERVER_API)}/api/teacherlessonmaterial/lessonmaterialAll?Lesson_id=${event.target.value}`
        );
        setLessonMaterials(response.data);
      } catch (error) {
        console.error("Error fetching lesson materials:", error);
        // toast.error("Failed to fetch lesson materials");
        setLessonMaterials([]);
      }
    }
  };

  const handleAdminLessonChange = async (event) => {
    setSelectedLessonTeacher(event.target.value);
    console.log("Admin Lesson", selectedLessonteacher);

    if (event.target.value && myteacherid) {
      try {
        const response = await axios.get(
          `${(process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_LOCAL_SERVER_API)}/api/teacherlessonmaterial/adminlessonmaterial?User_id=${userInfo.User_id}&Lesson_id=${event.target.value}`
        );
        setAdminLessonMaterials(response.data);
      } catch (error) {
        console.error("Error fetching admin lesson materials:", error);
        setAdminLessonMaterials([]);
      }
    } else {
      try {
        const response = await axios.get(
          `${(process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_LOCAL_SERVER_API)}/api/teacherlessonmaterial/adminlessonmaterialAll?Lesson_id=${event.target.value}`
        );
        setAdminLessonMaterials(response.data);
      } catch (error) {
        console.error("Error fetching admin lesson materials:", error);
        setAdminLessonMaterials([]);
      }
    }
  };

  const handleFileChange = (event) => {
    setUploadedFile(event.target.files[0]);
  };

  const handleAdminFileChange = (event) => {
    setAdminUploadedFile(event.target.files[0]);
  };

  const handleUpload = async () => {
    if (!selectedLessonteacher || !uploadedFile) {
      toast.error("Please select a lesson and upload a file.");
      return;
    }
    if (!materialDescription) {
      toast.error("Please add a description first.");
      return;
    }

    const formData = new FormData();
    formData.append("Lesson_id", selectedLessonteacher);
    formData.append("file", uploadedFile);
    formData.append("User_id", userInfo.User_id);
    formData.append("Course_id", selectedCourseData.Course_id);
    formData.append("description", materialDescription);

    try {
      const response = await axios.post(
        `${(process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_LOCAL_SERVER_API)}/api/teacherlessonmaterial/addlessonmaterial`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      toast.success("Material Uploaded Successfully");
      if (selectedLessonteacher && myteacherid) {
        try {
          const response = await axios.get(
            `${(process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_LOCAL_SERVER_API)}/api/teacherlessonmaterial/lessonmaterial?User_id=${userInfo.User_id}&Lesson_id=${selectedLessonteacher}`
          );
          setLessonMaterials(response.data);
        } catch (error) {
          console.error("Error fetching lesson materials:", error);
          // toast.error("Failed to fetch lesson materials");
          setLessonMaterials([]);
        }
      } else {
        try {
          const response = await axios.get(
            `${(process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_LOCAL_SERVER_API)}/api/teacherlessonmaterial/lessonmaterialAll?Lesson_id=${selectedLessonteacher}`
          );
          setLessonMaterials(response.data);
        } catch (error) {
          console.error("Error fetching lesson materials:", error);
          // toast.error("Failed to fetch lesson materials");
          setLessonMaterials([]);
        }
      }
      // setSelectedLessonTeacher("");
      setUploadedFile(null);
      setMaterialDescription("");
      document.getElementById("fileinput").value = "";
    } catch (error) {
      toast.error("Failed to upload material");
      console.error(error);
    }
  };

  const handleAdminUpload = async () => {
    if (!selectedLessonteacher || !adminUploadedFile) {
      toast.error("Please select a lesson and upload a file.");
      return;
    }
    if (!adminMaterialDescription) {
      toast.error("Please add a description first.");
      return;
    }

    const formData = new FormData();
    formData.append("Lesson_id", selectedLessonteacher);
    formData.append("file", adminUploadedFile);
    formData.append("User_id", userInfo.User_id);
    formData.append("Course_id", selectedCourseData.Course_id);
    formData.append("description", adminMaterialDescription);

    try {
      const response = await axios.post(
        `${(process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_LOCAL_SERVER_API)}/api/teacherlessonmaterial/addadminlessonmaterial`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      toast.success("Admin Material Uploaded Successfully");
      if (selectedLessonteacher && myteacherid) {
        try {
          const response = await axios.get(
            `${(process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_LOCAL_SERVER_API)}/api/teacherlessonmaterial/adminlessonmaterial?User_id=${userInfo.User_id}&Lesson_id=${selectedLessonteacher}`
          );
          setAdminLessonMaterials(response.data);
        } catch (error) {
          console.error("Error fetching admin lesson materials:", error);
          setAdminLessonMaterials([]);
        }
      } else {
        try {
          const response = await axios.get(
            `${(process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_LOCAL_SERVER_API)}/api/teacherlessonmaterial/adminlessonmaterialAll?Lesson_id=${selectedLessonteacher}`
          );
          setAdminLessonMaterials(response.data);
        } catch (error) {
          console.error("Error fetching admin lesson materials:", error);
          setAdminLessonMaterials([]);
        }
      }
      // setSelectedLessonTeacher("");
      setAdminUploadedFile(null);
      setAdminMaterialDescription("");
      document.getElementById("adminfileinput").value = "";
    } catch (error) {
      toast.error("Failed to upload admin material");
      console.error(error);
    }
  };

  return (
    <>
      {/* Navbar */}
      {username && (
        <>
          {isAdmin && (
            <AdminNav
              username={username}
              avatar={_avatar_}
              onLogout={onLogout}
            />
          )}
          {isTeacher && (
            <TeacherNav
              onCourseSelect={handleCourseSelect}
              username={username}
              avatar={_avatar_}
              onLogout={onLogout}
            />
          )}
          {isStudent && (
            <StudentNav
              username={username}
              avatar={_avatar_}
              onLogout={onLogout}
            />
          )}
        </>
      )}
      {!username && <>{isGuest && <GuestNav onLogin={onLogin} />}</>}

      <div className="attendClass-container">
        <Header title="Attend Class" />
        <div className="cards-grid">
          <div className="joinClass">
            <h2 className="course--title">{selectedCourseData.coursename}</h2>

            <div className="join-button-container">
              <button
                className="joinBtn"
                onClick={() => window.open(`${currentClassLink}`, "_blank")}
              >
                Join Class
              </button>
            </div>

            <div className="lesson-layout">
              <div className="lessonPlan">
                <h3>Lesson Plan</h3>
                <div className="lesson-selectors">
                  <div className="module-dropdown">
                    {courseModules ? (
                      <select
                        onChange={(e) => {
                          const selectedModuleId = e.target.value;
                          setSelectedModule(selectedModuleId);
                          if (selectedModuleId) {
                            const filteredLessons = courseLessons.filter(
                              (lesson) => lesson.Module_id == selectedModuleId
                            );
                            setFilteredLessons(filteredLessons);
                          } else {
                            setFilteredLessons([]);
                          }
                        }}
                        className="dropdown"
                      >
                        <option value="">Select Module</option>
                        {courseModules.map((module, index) => (
                          <option key={index} value={module.Module_id}>
                            {module.moduleName}
                          </option>
                        ))}
                      </select>
                    ) : (
                      <select
                        className="MAdropdown-menu MAdropdown-fixed-width"
                        name="module"
                      >
                        <option value="">No Modules available</option>
                      </select>
                    )}
                  </div>

                  <div className="lesson-dropdown">
                    {selectedModule ? (
                      filteredLessons && filteredLessons.length > 0 ? (
                        <select
                          name=""
                          id=""
                          className="dropdown"
                          onChange={handleLessonChange}
                        >
                          <option value="">Select Lesson</option>
                          {filteredLessons.map((lesson, index) => (
                            <option key={index} value={lesson.Lesson_id}>
                              {lesson.lessonName}
                            </option>
                          ))}
                        </select>
                      ) : (
                        <select
                          className="MAdropdown-menu MAdropdown-fixed-width"
                          name="course"
                        >
                          <option value="">
                            No Lessons available for this module
                          </option>
                        </select>
                      )
                    ) : (
                      <select
                        className="MAdropdown-menu MAdropdown-fixed-width"
                        name="course"
                        disabled
                      >
                        <option value="">Select Module First</option>
                      </select>
                    )}
                  </div>
                </div>

                {lessonPlanData && (
                  <div className="lesson-faq-list">
                    {lessonPlanData.map((faq, index) => (
                      <div key={index}>
                        <h6
                          onClick={() => handleClick(index)}
                          className={`lesson-faq-item ${activeIndex === index ? "active" : ""
                            }`}
                        >
                          <span>
                            {faq.itemname} ({faq.itemtime} minutes)
                          </span>
                          <span className="faq-toggle-icon">
                            {activeIndex === index ? "^" : "▼"}
                          </span>
                        </h6>
                        {activeIndex === index && (
                          <div className="lesson-faq-details">
                            {formatLessonPlanText(faq.itemdetails)}
                          </div>
                        )}
                      </div>
                    ))}
                  </div>
                )}
              </div>

              {lessonActivities && (
                <>
                  <div className="lessonPlan">
                    <h3>Lesson Activities</h3>
                    <ul>
                      {lessonActivities.map((activity, index) => (
                        <a
                          style={{ color: "#03b4c6" }}
                          className="LessonActivities"
                          key={index}
                        >
                          {activity.ActivityType == "Written" && (
                            <>
                              <img
                                src={WrittenActivityImage}
                                alt="WrittenLogo"
                                className="ActivitiesLogo"
                              />
                              <a
                                onClick={() =>
                                  handleActivityClick(
                                    activity.ActivityType,
                                    activity.Lesson_Activity_ID
                                  )
                                }
                                title={activity.ActivityName}
                              >
                                {truncateActivityName(activity.ActivityName)}
                              </a>
                              <img
                                src={eyeIcon}
                                alt="View"
                                className="activity-eye-icon"
                                onClick={() =>
                                  handleOpenDialog(activity.Lesson_Activity_ID)
                                }
                              />
                            </>
                          )}
                          {activity.ActivityType == "Video" && (
                            <>
                              <img
                                src={VideoActivityImage}
                                alt="VideoLogo"
                                className="ActivitiesLogo"
                              />
                              <a
                                onClick={() =>
                                  handleActivityClick(
                                    activity.ActivityType,
                                    activity.Lesson_Activity_ID
                                  )
                                }
                                title={activity.ActivityName}
                              >
                                {truncateActivityName(activity.ActivityName)}
                              </a>
                            </>
                          )}
                          {activity.ActivityType == "MCQ" && (
                            <>
                              <img
                                src={MCQActivityImage}
                                alt="MCQLogo"
                                className="ActivitiesLogo"
                              />
                              <a
                                onClick={() =>
                                  handleActivityClick(
                                    activity.ActivityType,
                                    activity.Lesson_Activity_ID
                                  )
                                }
                                title={activity.ActivityName}
                              >
                                {truncateActivityName(activity.ActivityName)}
                              </a>
                              <img
                                src={eyeIcon}
                                alt="View"
                                className="activity-eye-icon"
                                onClick={() =>
                                  handleOpenDialog(activity.Lesson_Activity_ID)
                                }
                              />
                            </>
                          )}
                          {activity.ActivityType == "Speed Quiz" && (
                            <>
                              <img
                                src={SpeedQuizActivityImage}
                                alt="SpeedQuizLogo"
                                className="ActivitiesLogo"
                              />
                              <a
                                onClick={() =>
                                  handleActivityClick(
                                    activity.ActivityType,
                                    activity.Lesson_Activity_ID
                                  )
                                }
                                title={activity.ActivityName}
                              >
                                {truncateActivityName(activity.ActivityName)}
                              </a>
                              <img
                                src={eyeIcon}
                                alt="View"
                                className="activity-eye-icon"
                                onClick={() =>
                                  handleOpenDialog(activity.Lesson_Activity_ID)
                                }
                              />
                            </>
                          )}
                          {activity.ActivityType == "Mental" && (
                            <>
                              <img
                                src={MentalActivityImage}
                                alt="MentalLogo"
                                className="ActivitiesLogo"
                              />
                              <a
                                onClick={() =>
                                  handleActivityClick(
                                    activity.ActivityType,
                                    activity.Lesson_Activity_ID
                                  )
                                }
                                title={activity.ActivityName}
                              >
                                {truncateActivityName(activity.ActivityName)}
                              </a>
                              <img
                                src={eyeIcon}
                                alt="View"
                                className="activity-eye-icon"
                                onClick={() =>
                                  handleOpenDialog(activity.Lesson_Activity_ID)
                                }
                              />
                            </>
                          )}
                          {activity.ActivityType == "Oral" && (
                            <>
                              <img
                                src={OralActivityImage}
                                alt="OralLogo"
                                className="ActivitiesLogo"
                              />
                              <a
                                onClick={() =>
                                  handleActivityClick(
                                    activity.ActivityType,
                                    activity.Lesson_Activity_ID
                                  )
                                }
                                title={activity.ActivityName}
                              >
                                {truncateActivityName(activity.ActivityName)}
                              </a>
                              <img
                                src={eyeIcon}
                                alt="View"
                                className="activity-eye-icon"
                                onClick={() =>
                                  handleOpenDialog(activity.Lesson_Activity_ID)
                                }
                              />
                            </>
                          )}
                          {activity.ActivityType == "Game" && (
                            <>
                              <img
                                src={puzzleicon}
                                alt="GameLogo"
                                className="ActivitiesLogo"
                              />
                              <a
                                onClick={() =>
                                  handleActivityClick(
                                    activity.ActivityType,
                                    activity.Lesson_Activity_ID,
                                    activity.ActivityLink
                                  )
                                }
                                title={activity.ActivityName}
                              >
                                {truncateActivityName(activity.ActivityName)}
                              </a>
                            </>
                          )}
                          <hr />
                        </a>
                      ))}
                    </ul>

                    {isDialogOpen && (
                      <ViewActivityModal
                        isOpen={isDialogOpen}
                        onClose={handleCloseDialog}
                        lessonActivityID={selectedLessonActivityID}
                      />
                    )}
                  </div>

                  <div className="lessonPlan">
                    <h3>Lesson Projects</h3>
                    <ul>
                      {lessonProjects && (
                        <>
                          {lessonProjects.map((project, index) => (
                            <a
                              style={{ color: "#03b4c6" }}
                              className="LessonActivities"
                              key={index}
                              href={project?.projectassignmenturl}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              {project.projectassignmentname}
                              <br />
                              <hr />
                            </a>
                          ))}
                        </>
                      )}
                    </ul>
                  </div>
                </>
              )}

              {!lessonActivities && (
                <div className="lessonPlan">
                  <h3>No Lessons </h3>
                </div>
              )}
            </div>
          </div>

          <div className="module-projects-wrapper">
            <div className="lessonPlan">
              <h3>Module Projects</h3>
              <select
                name=""
                id=""
                className="lessonOption"
                onChange={handleModuleChange}
              >
                <option value="">Select Module</option>
                {courseModules &&
                  courseModules.map((module, index) => (
                    <option key={index} value={module.Module_id}>
                      {module.moduleName}
                    </option>
                  ))}
              </select>

              {moduleProjects ? (
                <div className="project-list">
                  <ul>
                    {moduleProjects.map((project, index) => (
                      <a
                        className="LessonActivities project-link"
                        key={index}
                        href={project?.projectassignmenturl}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {project.projectassignmentname}
                        <hr />
                      </a>
                    ))}
                  </ul>
                </div>
              ) : (
                <div className="lessonPlan">
                  <h3>No Modules</h3>
                </div>
              )}
            </div>

            <div className="lessonPlan student-progress-panel">
              <h3>Student Progress</h3>
              <select
                name=""
                id=""
                className="lessonOption"
                onChange={handleStudentChange}
              >
                <option value="">Select Student</option>
                {courseStudents &&
                  courseStudents.map((student, index) => (
                    <option key={index} value={student.Student_id}>
                      {student.firstname + " " + student.lastname}
                    </option>
                  ))}
              </select>

              {assignedLesson && (
                <div className="current-assigned-indicator" style={{
                  backgroundColor: '#f0f9ff',
                  borderLeft: '4px solid #03b4c6',
                  padding: '8px 12px',
                  marginTop: '15px',
                  borderRadius: '4px',
                  fontSize: '14px',
                  color: '#0284c7'
                }}>
                  <strong>Currently Assigned:</strong> {assignedLesson.name}
                  {(selectedLesson == assignedLesson.id) && (
                    <span style={{
                      marginLeft: '10px',
                      color: '#059669',
                      backgroundColor: '#d1fae5',
                      padding: '2px 6px',
                      borderRadius: '10px',
                      fontSize: '12px',
                      fontWeight: 'bold'
                    }}>
                      (ACTIVE)
                    </span>
                  )}
                </div>
              )}

              <br />
              <br />

              <input
                className="student-message-input"
                type="text"
                placeholder="Type message"
              />
              <button className="send--button">Send</button>

              {studentProgress ? (
                <ul>
                  {studentProgress.map((progress, index) => (
                    <a
                      className="LessonActivities student-progress-item"
                      key={index}
                    >
                      <div className="progress-row">
                        <div className="progress-left">
                          <div
                            className={`status-circle ${progress.MarksObtained !== null
                              ? progress.MarksObtainedPercentage >= 70 ||
                                (progress.Complete &&
                                  progress.ActivityType === "Video")
                                ? "green"
                                : "gray"
                              : "gray"
                              }`}
                          ></div>
                          <div>{progress.ActivityName}</div>
                        </div>
                        <div className="progress-right">
                          {(progress.MarksObtained == null ||
                            progress.MarksObtained <= 0) && (
                              <span className="marks-percentage">/(%)</span>
                            )}
                          {progress.MarksObtained != null &&
                            progress.MarksObtained > 0 && (
                              <span
                                className="marks-percentage clickable"
                                onClick={() =>
                                  handleActivityResultClick(
                                    selectedStudent,
                                    progress.Activity_id
                                  )
                                }
                              >
                                {progress.MarksObtained}/{progress.TotalMarks} (
                                {Math.round(
                                  (progress.MarksObtained /
                                    progress.TotalMarks) *
                                  100
                                )}
                                %)
                              </span>
                            )}
                        </div>
                      </div>
                      <hr />
                    </a>
                  ))}
                </ul>
              ) : (
                <div className="lessonPlan">
                  <h3>No Student Selected</h3>
                </div>
              )}
            </div>
          </div>

          <div className="material-sharing-wrapper">
            {/* Teacher Lesson Material Sharing */}
            <div className="material-section">
              <div className="lessonPlan material-panel">
                <h3>Teacher Material Sharing</h3>
                {courseLessons ? (
                  <select
                    name=""
                    id=""
                    className="lessonOption"
                    onChange={handleTeacherLessonChange}
                  >
                    <option value="">Select Lesson</option>
                    {courseLessons.map((lesson, index) => (
                      <option key={index} value={lesson.Lesson_id}>
                        {lesson.lessonName}
                      </option>
                    ))}
                  </select>
                ) : (
                  <select
                    className="MAdropdown-menu MAdropdown-fixed-width"
                    name="course"
                  >
                    <option value="">No Lessons available</option>
                  </select>
                )}

                <input
                  type="text"
                  placeholder="Enter material description (max 100 characters)"
                  maxLength={100}
                  value={materialDescription}
                  onChange={(e) => setMaterialDescription(e.target.value)}
                  required
                  className="material-input"
                />
                <input type="file" id="fileinput" onChange={handleFileChange} />
                <button className="upload--btn" onClick={handleUpload}>
                  Upload
                </button>

                {/* Display Teacher Materials */}
                <div className="material-list">
                  <h4>Uploaded Materials:</h4>
                  {lessonMaterials.length > 0 ? (
                    <ul>
                      {lessonMaterials.map((material, index) => (
                        <li key={index} className="material-item">
                          <a
                            href={`${(process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_LOCAL_SERVER_API)}/public/Teacher_Lesson_Material/${material.url}`}
                            download={material?.description || material.url}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="material-link"
                            onClick={async (e) => {
                              e.preventDefault();
                              try {
                                const response = await fetch(
                                  `${(process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_LOCAL_SERVER_API)}/public/Teacher_Lesson_Material/${material.url}`
                                );
                                const blob = await response.blob();
                                const url = window.URL.createObjectURL(blob);
                                const link = document.createElement("a");
                                link.href = url;
                                link.download =
                                  material?.description || material.url;
                                document.body.appendChild(link);
                                link.click();
                                document.body.removeChild(link);
                                window.URL.revokeObjectURL(url);
                              } catch (error) {
                                console.error("Download failed:", error);
                                window.open(
                                  `${(process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_LOCAL_SERVER_API)}/public/Teacher_Lesson_Material/${material.url}`,
                                  "_blank"
                                );
                              }
                            }}
                          >
                            {material?.description}
                          </a>
                          <span className="material-meta">
                            (Uploaded on: {new Date(material.date).getDate()}{" "}
                            {new Date(material.date).toLocaleDateString(
                              undefined,
                              {
                                month: "long",
                              }
                            )}{" "}
                            {new Date(material.date).getFullYear()} by{" "}
                            {material?.firstname} {material?.lastname})
                          </span>
                        </li>
                      ))}
                    </ul>
                  ) : (
                    <p>No materials uploaded for this lesson yet.</p>
                  )}
                </div>
              </div>
            </div>

            {/* Admin Lesson Material Sharing */}
            <div className="material-section">
              <div className="lessonPlan material-panel">
                <h3>Admin Material Sharing</h3>
                {courseLessons ? (
                  <select
                    name=""
                    id=""
                    className="lessonOption"
                    onChange={handleAdminLessonChange}
                  >
                    <option value="">Select Lesson</option>
                    {courseLessons.map((lesson, index) => (
                      <option key={index} value={lesson.Lesson_id}>
                        {lesson.lessonName}
                      </option>
                    ))}
                  </select>
                ) : (
                  <select
                    className="MAdropdown-menu MAdropdown-fixed-width"
                    name="course"
                  >
                    <option value="">No Lessons available</option>
                  </select>
                )}

                {isAdmin && (
                  <>
                    <input
                      type="text"
                      placeholder="Enter material description (max 100 characters)"
                      maxLength={100}
                      value={adminMaterialDescription}
                      onChange={(e) =>
                        setAdminMaterialDescription(e.target.value)
                      }
                      required
                      className="material-input"
                    />
                    <input
                      type="file"
                      id="adminfileinput"
                      onChange={handleAdminFileChange}
                    />
                    <button className="upload-btn" onClick={handleAdminUpload}>
                      Upload
                    </button>
                  </>
                )}

                <div className="material-list">
                  <h4>Uploaded Materials:</h4>
                  {adminLessonMaterials.length > 0 ? (
                    <ul>
                      {adminLessonMaterials.map((material, index) => (
                        <li key={index} className="material-item">
                          <a
                            href={`${(process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_LOCAL_SERVER_API)}/public/Teacher_Lesson_Material/${material.url}`}
                            download={material?.description || material.url}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="material-link"
                            onClick={async (e) => {
                              e.preventDefault();
                              try {
                                const response = await fetch(
                                  `${(process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_LOCAL_SERVER_API)}/public/Teacher_Lesson_Material/${material.url}`
                                );
                                const blob = await response.blob();
                                const url = window.URL.createObjectURL(blob);
                                const link = document.createElement("a");
                                link.href = url;
                                link.download =
                                  material?.description || material.url;
                                document.body.appendChild(link);
                                link.click();
                                document.body.removeChild(link);
                                window.URL.revokeObjectURL(url);
                              } catch (error) {
                                console.error("Download failed:", error);
                                window.open(
                                  `${(process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_LOCAL_SERVER_API)}/public/Teacher_Lesson_Material/${material.url}`,
                                  "_blank"
                                );
                              }
                            }}
                          >
                            {material?.description}
                          </a>
                          <span className="material-meta">
                            (Uploaded on: {new Date(material.date).getDate()}{" "}
                            {new Date(material.date).toLocaleDateString(
                              undefined,
                              {
                                month: "long",
                              }
                            )}{" "}
                            {new Date(material.date).getFullYear()} by{" "}
                            {material?.firstname} {material?.lastname})
                          </span>
                        </li>
                      ))}
                    </ul>
                  ) : (
                    <p>No admin materials uploaded for this lesson yet.</p>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
        {isRefreshing && (
          <div
            style={{
              position: "fixed",
              top: "20px",
              right: "20px",
              backgroundColor: "#4CAF50",
              color: "white",
              padding: "8px 16px",
              borderRadius: "4px",
              zIndex: 1000,
              display: "flex",
              alignItems: "center",
              gap: "8px",
              boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
              animation: "fadeInOut 0.5s ease-in-out",
            }}
          >
            <div
              style={{
                width: "16px",
                height: "16px",
                border: "2px solid #ffffff",
                borderTop: "2px solid transparent",
                borderRadius: "50%",
                animation: "spin 1s linear infinite",
              }}
            />
            Updating Progress...
          </div>
        )}
      </div>
    </>
  );
};

export default TeacherAttendClass;
